<div class="cycle-type-selector-container">
    <h1 class="title" style="width: 500px; margin-top: -50px">{{ "cyclePartner.selectLayout" | translate }}</h1>
    <div class="cycle-card-container">
        <div class="cycle-card-selector with-logo" (click)="goToAddCycle()">
            <div class="logo-container">
                <img [src]="logoSrc" alt="Ciclo Normal" />
            </div>
            <p class="title">{{ "cyclePartner.newBTGCycle" | translate }}</p>
            <p class="text">
                {{ "cyclePartner.createNewBTGCycle" | translate }}:<br />
                {{ "cyclePartner.infoByBTG" | translate }}
            </p>
        </div>
        <div class="cycle-card-selector" (click)="goToAddCyclePartner()">
            <img src="./assets/imgs/new-dashboard.svg" alt="Ciclo Parceiro" />
            <p class="title">{{ "cyclePartner.newDashboard" | translate }}</p>
            <p class="text">{{ "cyclePartner.personalizatedInfo" | translate }}</p>
        </div>
    </div>
    <div style="width: 500px">
        <ion-button mode="ios" fill="outline" (click)="dismiss()">
            {{ "generic.cancel" | translate }}
        </ion-button>
    </div>
</div>
